import { FunctionComponent, ReactNode } from "react";

interface Props {
  children: ReactNode;
  withNegativeMarginLeft?: boolean;
}

const PageContentCentered: FunctionComponent<Props> = ({
  children,
  withNegativeMarginLeft
}) => {
  // Note that because of root.tsx brings us `ml-[150px]` because we need it as space allocation for Sidebar, here, using `-ml-[150px]`
  // we kinda decline that margin-left, to fill the entire viewport width and height, enabling flex centering content in the middle both vertically and horizontally.

  return (
    <main
      className={`${withNegativeMarginLeft ? "-ml-[150px]" : ""} flex h-screen w-screen grow items-center justify-center text-center`}
    >
      <div className="flex flex-col items-center">{children}</div>
    </main>
  );
};

export default PageContentCentered;
